import { getClasses } from '@/_utils/classnames';
import styles from './NoteCounter.module.css';
import { type FC } from 'react';
import { Icon } from '@/_components';
import type { NoteCounterProps } from './NoteCounter.types';

export const NoteCounter: FC<NoteCounterProps> = ({
  noteCount = 0,
  onClick,
}) => {
  const noteCounterClasses: string = getClasses(styles.noteCounter, {
    [styles.noteCounterCount]: noteCount > 0,
  });

  return (
    <div
      className={noteCounterClasses}
      data-component="NoteCounter"
      onClick={onClick || undefined}
    >
      {noteCount}
      <Icon name="note" size={16} />
    </div>
  );
};
